import stampit from 'stampit';
const Reference = stampit({
  props: {
    uri: '',
    value: null,
    depth: 0,
    refSet: null,
    errors: []
  },
  init({
    depth = this.depth,
    refSet = this.refSet,
    uri = this.uri,
    value = this.value
  } = {}) {
    this.uri = uri;
    this.value = value;
    this.depth = depth;
    this.refSet = refSet;
    this.errors = [];
  }
});
export default Reference;